export default __webpack_public_path__ + "static/media/ticket.33d24007.png";